// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__J8Yxq","rootMobile":"styles_rootMobile__2tIfr"};